<template>
  <div>

    <div id="pswrapper">
      <p>
        myCSUB has been updated to use CSUB Single Sign-On service. Click the link below to log in using your CSUB email and password.
      </p>
      <p v-if="allowLogin">
        <a :href="buttonLoc" class="btn">Click here to log into myCSUB</a>
      </p>
      <p v-else>
        <button class="btn btn-secondary" disabled>Maintenance in progress.</button>
      </p>
      <hr />
    </div>

    <div class="maint">
      <p v-html="maintMessage"></p>
      <p v-if="secondary_message">{{ secondary_message }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'maint',
  data () {
    return {
      useDefaultMaintMsg: Boolean,
      allowLogin: Boolean,
      maintMessage: '',
      secondary_message: '',
      buttonLoc: 'https://cmsweb.cms.csub.edu/psp/CBAKPRD/?cmd=login'
    }
  },

  async created () {
    const { data: jsonData } = await axios.get('https://www.csub.edu/data/cms/mycsub-myhr-maintenance-message.json?nocache' + (new Date()).getTime())
    this.useDefaultMaintMsg = jsonData.useDefault
    this.maintMessage = jsonData.message
    this.allowLogin = jsonData.allowLogin
    this.secondary_message = jsonData.secondary_message
  },

  methods: {
    dispMaint: function () {
      var now = new Date()
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

      // Checks day and time on when to display maintenance message.
      if (now.getDay() === 1 && now.getHours() >= 6 && now.getHours() < 22 && this.useDefaultMaintMsg) {
        this.maintMessage = 'myCSUB will be unavailable on ' + days[now.getDay()] + ', ' + months[now.getMonth()] + ' ' + now.getDate() + ' from 6:00PM-10:00PM for scheduled maintenance.'
        // Checks day and time on when to disable login button
        if (now.getHours() >= 18 && now.getHours() < 22) {
          this.allowLogin = false
        }
      } else if (this.useDefaultMaintMsg) {
        this.maintMessage = ''
      }
    }
  },

  updated () {
    // Shows maintenance message
    this.dispMaint()
  }
}
</script>

<style scoped>
  .maint {
    padding-left: 36px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #f00;
    font-size: 12px;
    width: 98%;
  }

  .btn {
    background: #003595;
    font-family: 'Oswald', sans-serif;
    font-size: 16px !important;
    color: #FFD200;
    /* font-weight: bold !important; */
  }

  .btn:hover {
    color: white !important;
  }
</style>
